/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promo_Movement_Submit_IntakeInputs */



/**
* | output |
* | --- |
* | "Record intake" |
*
* @param {Promo_Movement_Submit_IntakeInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promo_movement_submit_intake = /** @type {((inputs?: Promo_Movement_Submit_IntakeInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promo_Movement_Submit_IntakeInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enregistrer la réception")
	if (locale === "es") return /** @type {LocalizedString} */ ("Registrar recepción")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Registrar recebimento")
	if (locale === "it") return /** @type {LocalizedString} */ ("Registra la ricezione")
	return /** @type {LocalizedString} */ ("Record intake")
});